import React from 'react'
import { Dialog, DialogPanel, DialogBackdrop, DialogTitle, Transition } from '@headlessui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faXmarkCircle } from '@fortawesome/free-solid-svg-icons'
import ReferralModal from './ReferralModal'

const MarketingModal = ({ openMarketing, setOpenMarketing, onRefer, onInvite, handleClose }) => {
  // const handleClose = () => {
  //   const date = new Date().toString()
  //   localStorage.setItem('marketing', date)
  //   setOpenMarketing(false)
  // }

  return (
    <Transition show={openMarketing} as={React.Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <DialogBackdrop className="fixed inset-0 bg-black bg-opacity-30" />

        <div className="fixed inset-0 flex items-end justify-end p-4">
          <DialogPanel className="w-full max-w-md rounded-xl bg-white shadow-lg overflow-hidden">
            {/* Header */}
            <div className="flex items-start justify-between p-5 border-b border-gray-200">
              <div className="flex-1 text-center">
                <DialogTitle className="text-lg font-semibold text-gray-800">
                  Do you have a minute?
                </DialogTitle>
              </div>
              <button
                className="text-gray-500 hover:text-red-700"
                onClick={() => setOpenMarketing(false)}
              >
                <FontAwesomeIcon icon={faXmarkCircle} className="h-5 w-5" />
              </button>
            </div>

            {/* Body */}
            <div className="p-6 text-center">
              <p className="text-base font-medium text-gray-700 mb-6">
                Why don’t you refer a school or invite us to one of your meetings?
              </p>
              <div className="flex justify-center space-x-4">
                <button
                  onClick={() => {
                    onRefer()
                    setOpenMarketing(false)
                  }}
                  className="px-4 py-2 rounded-md bg-sas hover:bg-sas-dark text-white text-sm font-semibold shadow"
                >
                  Refer a School
                </button>
                <button
                  onClick={() => {
                    onInvite()
                    setOpenMarketing(false)
                  }}
                  className="px-4 py-2 rounded-md bg-sas hover:bg-sas-dark text-white text-sm font-semibold shadow"
                >
                  Invite us to a Meeting
                </button>
              </div>
            </div>

            {/* Footer */}
            <div className="bg-gray-50 px-6 py-3 border-t border-gray-200 text-center">
              <button
                onClick={handleClose}
                className="text-sm text-gray-500 hover:text-red-600 hover:underline"
              >
                Don’t ask me again
              </button>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </Transition>
  )
}

export default MarketingModal